// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	-webkit-text-size-adjust: 100%;
	margin: 0;
	padding: 0;
	font-size: 14px;
}

.careev-modal-spinner {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	overflow: visible;
	z-index: 1100;
}

.careev-modal-spinner .glass {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	opacity: 0.01;
	filter: alpha(opacity=1);
	background: #fff;
}

.careev-modal-spinner .loading-indicator-container {
	visibility: hidden;
	display: block;
	position: relative;
	left: 0;
	top: 48%;
	padding-top: 12px;
	padding-bottom: 12px;
	padding-left: 12px;
	padding-right: 12px;
	border-radius: 2px;
	box-shadow: 6px 6px 12px 0 black;
	width: 500px;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	width: 80%;
	max-width: 500px;
	background: white;
	color: #666;
	border-radius: 10px;
	box-shadow: 0px 0px 6px 0px #666
}

.careev-modal-spinner .loading-indicator-container .loading-indicator .loading-medium {
	font-size: 18px;
	font-weight: bold;
	line-height: 32px;
	vertical-align: middle;
}

.careev-modal-spinner .loading-indicator-container .loading-indicator .loading-medium img {
	height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MyDataHelps/global.css"],"names":[],"mappings":"AAAA;CACC,kJAAkJ;CAClJ,8BAA8B;CAC9B,SAAS;CACT,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,SAAS;CACT,QAAQ;CACR,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,SAAS;CACT,QAAQ;CACR,aAAa;CACb,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,gCAAgC;CAChC,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;CACX,mBAAmB;CACnB;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;CACC,YAAY;AACb","sourcesContent":["body {\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n\t-webkit-text-size-adjust: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\tfont-size: 14px;\n}\n\n.careev-modal-spinner {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\toverflow: visible;\n\tz-index: 1100;\n}\n\n.careev-modal-spinner .glass {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\topacity: 0.01;\n\tfilter: alpha(opacity=1);\n\tbackground: #fff;\n}\n\n.careev-modal-spinner .loading-indicator-container {\n\tvisibility: hidden;\n\tdisplay: block;\n\tposition: relative;\n\tleft: 0;\n\ttop: 48%;\n\tpadding-top: 12px;\n\tpadding-bottom: 12px;\n\tpadding-left: 12px;\n\tpadding-right: 12px;\n\tborder-radius: 2px;\n\tbox-shadow: 6px 6px 12px 0 black;\n\twidth: 500px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\ttext-align: center;\n\twidth: 80%;\n\tmax-width: 500px;\n\tbackground: white;\n\tcolor: #666;\n\tborder-radius: 10px;\n\tbox-shadow: 0px 0px 6px 0px #666\n}\n\n.careev-modal-spinner .loading-indicator-container .loading-indicator .loading-medium {\n\tfont-size: 18px;\n\tfont-weight: bold;\n\tline-height: 32px;\n\tvertical-align: middle;\n}\n\n.careev-modal-spinner .loading-indicator-container .loading-indicator .loading-medium img {\n\theight: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
